import Alpine from 'alpinejs';

Alpine.data('stickyBanner', (position = 0.2) => {
  return {
    position,
    visible: false,
    checkScrollPosition() {
      const scrollY = window.scrollY;
      const scrollableContent = document.documentElement.scrollHeight - window.innerHeight;
      const threshold = scrollableContent * this.position;

      this.visible = scrollY > threshold;
    },

    init() {
      this.checkScrollPosition();
    },
  };
});

Alpine.registerModule('stickyBanner');
